import init from './thing'

const person =
{
    ...init
};

export default person ;
